// extracted by mini-css-extract-plugin
module.exports = {"container":"main-layout_container__267KZ"};